module.exports = __webpack_public_path__ + "static/media/deposit1.534f918e.png";